import { useEffect, useState, useRef, useCallback } from 'sb-hooks'


const getDoubleDigitNumber = (number) => String(number).padStart(2, '0')

const getText = (values) => {
  const { getMessage, timeLeft, withMilliseconds, withDoubleDigitNumber } = values

  const messageValues = {
    hours: Math.floor((timeLeft.current / 60 / 60 / 1000)),
    minutes: Math.floor((timeLeft.current / 60 / 1000) % 60),
    seconds: Math.floor((timeLeft.current / 1000) % 60),
    milliseconds: withMilliseconds
      ? Math.floor((timeLeft.current % 1000 / 100))
      : null,
  }

  if (withDoubleDigitNumber) {
    Object.keys(messageValues).forEach((key) => {
      messageValues[key] = getDoubleDigitNumber(messageValues[key])
    })
  }

  return getMessage(messageValues)
}

const useCountdown = (values) => {
  const {
    getMessage, expiredMessage, nodeRef,
    withMilliseconds, withDoubleDigitNumber, initialTime = 20 * 60 * 1000, // 20 min
  } = values

  const initTime    = initialTime
  const tickTime    = withMilliseconds ? 100 : 1000
  const timeLeft    = useRef(initTime)
  const timer       = useRef(null)

  const [ isExpired, setExpired ] = useState(timeLeft.current <= tickTime)

  const tick = useCallback(() => {
    timeLeft.current -= tickTime

    if (timeLeft.current <= 0) {
      clearInterval(timer.current)
      setExpired(true)

      if (expiredMessage) {
        nodeRef.current.innerHTML = expiredMessage
      }

      return
    }

    nodeRef.current.innerHTML = getText({
      getMessage,
      timeLeft,
      withMilliseconds,
      withDoubleDigitNumber,
    })
  }, [])

  useEffect(() => {
    if (!nodeRef || !nodeRef.current) {
      // You can not send a ref link if the timer is expired
      return
    }

    if (!isExpired) {
      timer.current = setInterval(tick, tickTime)
      tick()
    }

    return () => {
      clearInterval(timer.current)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const countdownMessage = isExpired && expiredMessage
    ? expiredMessage
    : getText({
      getMessage,
      timeLeft,
      withMilliseconds,
      withDoubleDigitNumber,
    })

  return {
    isExpired,
    countdownMessage, // for SSR render
  }
}


export default useCountdown
